import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import enUS from "../locales/enUS/translation.json";
import jaJP from "../locales/jaJP/translation.json";
import koKR from "../locales/koKR/translation.json";
import zhTW from "../locales/zhTW/translation.json";
import deDE from "../locales/deDE/translation.json";
import deCH from "../locales/deCH/translation.json";
import deAT from "../locales/deAT/translation.json";
import frCH from "../locales/frCH/translation.json";
import itIT from "../locales/itIT/translation.json";
import nlNL from "../locales/nlNL/translation.json";
import daDK from "../locales/daDK/translation.json";
import nnNO from "../locales/nnNO/translation.json";
import svSE from "../locales/svSE/translation.json";

// THERE RESOURCES ARE IMPORTED FROM src/locales/ IN ORDER FOR
// THEM TO BE AVAILABLE IN THE BUNDLE THAT GETS CREATED DURING
// THE BUILD PROCESS. THE BUILD FILE IS THEN USED TO LOAD THE
// APP ON THE AEM WEBSITE.
const resources = {
  enUS,
  jaJP,
  koKR,
  zhTW,
  deDE,
  deCH,
  deAT,
  frCH,
  itIT,
  nlNL,
  daDK,
  nnNO,
  svSE,
};

// There is a chance for the app to fail here. This method assumes that
// the <hhtml /> lang property is set and follows the XX-XX format.
const parseDocumentLocale = () => {
  const hyphenatedLocale = document.documentElement.lang;
  const region = hyphenatedLocale.split("-")[1].toUpperCase();
  const parsedLocale = hyphenatedLocale.split("-")[0] + region;

  return parsedLocale;
};

i18n
  .use(LanguageDetector)
  // WE STILL USE THE BACKEND FEATURE. THIS CAN BE REMOVED IN THE FUTURE
  // IF IT CAUSES PERFORMANCE ISSUES. THIS IS A NICE TO HAVE WAS USED TO
  // HANDLE LOADING TRANSLATIONS ON THE GOOGLE CLOUD PLATOFRM SERVERS.
  // THIS FEATURE USES THE TRANSLATION FILES UNDER THE
  // public/locales/ DIR.
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources,
    // THIS LINE ALLOWS THE APP TO USE BOTH BACKEND AND "LOCAL"
    // TRANSLATION OPTIONS. IF THE BACKEND FEATURE IS REMOVED,
    // THIS SHOULD BE REMOVED AS WELL.
    partialBundledLanguages: true,
    fallbackLng: "enUS",
    lng: parseDocumentLocale(),
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
